import SavedPaymentDetailsForm from './SavedPaymentDetailsForm';

export default SavedPaymentDetailsForm;
